module.exports = __webpack_public_path__ + "static/media/motorSanadBlue.7fee42d5.svg";